<template>
  <div>
      <ed-modelo :intTipoModeloId="1321" :key="$root.$session.versao" :intId="this.$route.params.intId"/>
  </div>
</template>

<script>
import EdModelo from "@/components/lista/editar";
export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdModelo },
  mounted() {
    if (!this.$route.params.intId) {
      this.$router.push({ name: "marketing.lista" });
    }
  },
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>